module.exports = __webpack_public_path__ + "img/虎杖.c0f643bb.jpg";